import {IFormProps} from "../../../component/form/model/FormModel";
import {PostType} from "../../../../ts/manager/post/PostManager";
import BasicForm from "../../../component/form/BasicForm";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../../ts/manager/Manager";
import ToggleFIE from "../../../component/form/form-item-element/ToggleFIE";
import React from "react";
import AppButton from "../../../element/button/AppButton";
import TextAreaFIE from "../../../component/form/form-item-element/TextAreaFIE";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";

interface IProps extends IFormProps
{
    postType:PostType;
    postID:number
}

export default class DeclareYourInterestForm extends BasicForm
{
    props: IProps;

    constructor(props: IProps)
    {
        super(props);

        this.props = props;
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);

        return await getManager().api.fetchData("/post/" + this.props.postType+ "/" + this.props.postID + "/add_apply_activity", "POST", params, true);
    }

    handleSubmitComplete(responseVO: ApiResponseVO, submitType: string, formItemIDs: string[] | null)
    {
        super.handleSubmitComplete(responseVO, submitType, formItemIDs);
        const postActivityDataModel = getModelFactory().postActivityData.postActivityDataModel(getManager().user.organisationID);
        postActivityDataModel.resetPopulated()
    }

    renderComponent()
    {
        return <div className="container">
            <div className="row">
                <div className="col-12">
                    <form
                        onSubmit={this.handleFormSubmit}
                        className={"custom-form " +(this.isDisabled() ? "content-disabled" : "")}
                    >


                        <div className="row">
                            <div className="col-12">
                                <ToggleFIE
                                    form={this}
                                    formItemProps={{
                                        pointer: "notify_provider",
                                        required: true,
                                        name: "I would like the provider to be notified of my interest.",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <TextAreaFIE
                                    form={this}
                                    elementProps={{
                                        maxlength:1000
                                    }}
                                    formItemProps={{
                                        pointer: "further_information",
                                        name: "Please provide any information here that may help with your application."
                                    }}
                                    instructions="Up to 1000 characters"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ToggleFIE
                                    form={this}
                                    formItemProps={{
                                        pointer: "agree_to_share",
                                        required: true,
                                        name: "I agree that my contact details can be shared with the provider"
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {this.formAlerts()}
                                {this.requiredFieldsMessage()}
                            </div>

                            <div className="col-12">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Submit Notification of Interest
                                    </AppButton>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    }
}